<div class="modal-header">
  <h4 class="modal-title">{{ message }}</h4>
</div>
<div class="modal-body">
  <i class="fas fa-circle-notch fa-spin" style="font-size: 22px"></i>
  Please wait...
</div>
<!--<div class="modal-footer">-->
<!--</div>-->
